import moment from 'moment';
import config from "../config";

export const durationToString = (duration) => {
    if (!duration) {
        return '';
    }

    const durationHour = Math.floor(duration/3600);
    const durationMins = Math.floor((duration - durationHour*3600)/60);
    const durationSec = Math.floor((duration - durationHour*3600 - durationMins*60));
    const hourString = durationHour > 0 ? `${durationHour}h` : '';
    const minString = durationMins > 0 ? `${durationMins}m` : '';

    if (duration < 60) {
        return `${durationSec}s`;
    }
    return duration > 60 ? `${hourString} ${minString}` : '0m';
}


export const formatUnixTimestampForDatePicker = (unixTimestamp) => {
  const date = new Date(unixTimestamp * 1000);

  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';

  const formattedHours = hours % 12 || 12;

  return `${month}/${day}/${year} ${formattedHours}:${minutes} ${ampm}`;
}

export const getCurrentTimeZone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export const getTimezoneOffsetInSeconds = (date, timezone) => {
  const localMoment = moment.tz(date, timezone);
  return localMoment.utcOffset() * 60;
}

export const getTimezoneOffsetInSecondsByTimestamp = (unixTimestamp, timezone) => {
  const momentUnix = moment.unix(unixTimestamp);
  const momentFromUnix = moment.tz(momentUnix, timezone);
  return momentFromUnix.utcOffset() * 60;
}

export const makeTimestampForLocationTimeZoneByTime = (time) => {
  return moment(time).unix() + getTimezoneOffsetInSeconds(time, moment.tz.guess()) - getTimezoneOffsetInSeconds(time, config.default_tz);
}

export const makeTimestampForLocationTimeZone = (timestamp) => {
  return timestamp - getTimezoneOffsetInSecondsByTimestamp(timestamp, moment.tz.guess()) + getTimezoneOffsetInSecondsByTimestamp(timestamp, config.default_tz);
}




// WEBPACK FOOTER //
// ./src/utils/date.js